import { z } from "zod";

export const bulletListPropsSchema = z.object({
  heading: z.string().optional().nullable(),
  subheading: z.string().optional().nullable(),
  items: z.array(z.string().min(3)).min(1),
});

export const cmsBulletListPropsSchema = z.object({
  heading: z.string().optional().nullable(),
  subheading: z.string().optional().nullable(),
  items: z
    .array(
      z.object({
        value: z.string().min(3),
      }),
    )
    .min(1)
    .transform((items) => items.map((item) => item.value)),
});
